/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
import React from "react";
import DependencyValidator from "../dependency-validator";

import { Container, TitleEl } from "./styles";

interface TitleObject {
  value: string;
  color?: string;
}

type IProps = any & {
  title: TitleObject[] | string;
  handleClick: (index: number) => void;
};

const Textline: React.FC<IProps> = ({ title, handleClick, ...el }: IProps) => {
  const titlesArray = Array.isArray(title) ? title : [{ value: title }];

  return (
    <DependencyValidator {...el}>
      <Container {...el}>
        {titlesArray.map((titleObj, index) => (
          <>
            <TitleEl key={titleObj.value} style={{ color: titleObj.color }}>
              {titleObj.value}
              <span onClick={() => handleClick(index)}>X</span>
            </TitleEl>
          </>
        ))}
      </Container>
    </DependencyValidator>
  );
};

export default Textline;
